module.exports = __webpack_public_path__ + "static/img/partner_24.7919bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_24.png
// module id = YEYA
// module chunks = 0